import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import LoadingSpinner from '../../../components/loading-spinner';
import Input from "../../../components/input";
import Modal from "../../../components/modal";
import SelectInput from "../../../components/select";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {ReactComponent as ReactLogo} from '../../../button.svg';
import { searchProcessMonthlyMonitoring } from "../../../redux/activities";
import {searchProcess} from "../../../redux/work_process";
import {
    clear_activity,
    CREATE_ACTIVITY,
    createActivity,
    searchActivityItem
} from "../../../redux/activities";
// import {URLAPI} from "../../../config";
import Search from "../../../components/search";
import Footer from "../../../components/footer";

const MonthlyMonitoringProcess = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {id_hoja_trabajo, hoja_trabajo, id_proceso_trabajo, proceso, mes, anio, id_usuario, usuario, id_tienda, tienda} = useParams();
    
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const _create_activity = useSelector((state) => state.activities_module._create_activity);

    const [id_process, setIdProcess] = useState(id_proceso_trabajo);
    const [work_process, setWorkProcess] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [datas, setDatas] = useState([]);
    const [item, setItem] = useState({});
    const [data, setData] = useState({});
    const [month, setMonth] = useState('');
    const [modal, setModal] = useState(false);
    const [modalItem, setModalItem] = useState(false);
    const [modalCreateActivity, setModalCreateActivity] = useState(false);
    const [fecha_agendada, setFechaAgendada] = useState('');

    const filter_month = [
        {name: "Enero", id: 1},
        {name: "Febrero", id: 2},
        {name: "Marzo", id: 3},
        {name: "Abril", id: 4},
        {name: "Mayo", id: 5},
        {name: "Junio", id: 6},
        {name: "Julio", id: 7},
        {name: "Agosto", id: 8},
        {name: "Septiembre", id: 9},
        {name: "Octubre", id: 10},
        {name: "Noviembre", id: 11},
        {name: "Diciembre", id: 12}
    ];

    useEffect(() => {
        let m = filter_month.filter(x => x.id === parseInt(mes));
        setMonth(m[0].name);
        getWorkProcess();
        getProcessMonthlyMonitoring(id_process);
        // eslint-disable-next-line
    }, [id_hoja_trabajo, id_proceso_trabajo, proceso, mes, anio, id_usuario, id_tienda]);

    async function getWorkProcess() {
        setIsLoading(true);
        const params = '?id_hoja_trabajo=' + id_hoja_trabajo
        try {
            const response = await searchProcess(token, params);
            if (response && response.data && response.data.datos) {
                let v = response.data.datos.filter(x => x.activo === true);
                setWorkProcess(v);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    async function getProcessMonthlyMonitoring(id_proceso) {
        setIsLoading(true);
        if (id_process === 0) {
            toast.error("Debe seleccionar un proceso", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        
        let v_month = mes.toString()
        if (v_month.length === 1) {
            v_month = '0' + v_month;
        }
        var day = (new Date(anio, v_month, 0)).getDate();
        const date_start = anio.toString() + '-' + v_month.toString() + '-01';
        const date_end = anio.toString() + '-' + v_month.toString() + '-' + day.toString();
        let params = '?id_usuario=' + id_usuario + '&&id_tienda=' + id_tienda + '&&id_proceso_trabajo=' + id_proceso + '&&fecha_inicio=' + date_start + '&&fecha_fin=' + date_end;
        try {
            const response = await searchProcessMonthlyMonitoring(token, params);
            if (response && response.data && response.data.datos) {
                setDatas(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    async function getActivity(id_actividad) {
        setIsLoading(true);
        try {
            const response = await searchActivityItem(token, id_actividad);
            if (response && response.data && response.data.datos) {
                let v = response.data.datos;
                setData(v);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    useEffect(() => {
        if (_create_activity.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_activity(CREATE_ACTIVITY));
            getProcessMonthlyMonitoring(id_process);
            setIsLoading(false);
            setModalCreateActivity(false);
            setModal(false);
        } else if (_create_activity.status !== 0) {
            dispatch(clear_activity(CREATE_ACTIVITY));
            toast.error(_create_activity.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_activity, dispatch, history, id_process]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // setIsLoading(true);
        if (fecha_agendada === "") {
            toast.error("Debe seleccionar una fecha", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        let value = {
            id_actividad_trabajo: item.id_actividad_trabajo,
            id_tienda: item.id_tienda,
            fecha_agendada: fecha_agendada,
            tarea_reemplazo: false,
            id_usuario: id_usuario,
        }
        dispatch(createActivity(token, value))
    };

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            getProcessMonthlyMonitoring(id_process);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = datas.filter(element => {
            if (element.actividad_trabajo.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                    <Breadcrumbs
                            title="Seguimiento mensual"
                            items={[{label: "Consulta de acividades", link: "/segumiento-mensual"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="d-flex">
                                    <div style={{cursor: 'pointer'}} onClick={() => {
                                        history.push(`/seguimiento/${id_hoja_trabajo}/${hoja_trabajo}/${id_usuario}/${usuario}/${id_tienda}/${tienda}/${mes}/${anio}`);
                                    }}>
                                        <ReactLogo width={50} heght={40}/>
                                    </div>
                                    <p className="ml-1" style={{marginTop: 5, fontSize: 18, color: '#727E8C'}}>Cumplimiento de procesos {month} {anio}</p>
                                </div>
                                <div className="row mt-1">
                                    <div className="col-12">
                                        <div className="border_card row">
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>Proceso</label>
                                                    <SelectInput
                                                        label="Proceso"
                                                        name="id_process"
                                                        value={id_process}
                                                        select={proceso}
                                                        onChange={(e) => {
                                                            if (parseInt(e.target.value) !== 0) {
                                                                setIdProcess(parseInt(e.target.value));
                                                                getProcessMonthlyMonitoring(parseInt(e.target.value));  
                                                            } else {
                                                                setDatas([]);
                                                            }
                                                        }}
                                                        options={work_process ? work_process.map((wp) => ({
                                                            name: wp.nombre,
                                                            id: wp.id,
                                                        })) : []}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className="col-12">
                                        <Search placeholder={"Buscar por actividad"}
                                                onChange={handleSearch}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className='table table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th className="text-center">Actividad</th>
                                                        <th className="text-center">Subproceso</th>
                                                        <th className="text-center">Tienda</th>
                                                        <th className="text-center">Agendadas</th>
                                                        <th className="text-center">Terminadas</th>
                                                        <th className="text-center">Omitidas</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {datas &&
                                                        datas.map(v => (
                                                            <tr style={{background: v.color}} onClick={() =>{
                                                                setItem(v);
                                                                setModal(true);
                                                            }}>
                                                                <td>{v.actividad_trabajo}</td>
                                                                <td>{v.subproceso_trabajo}</td>
                                                                <td>{v.tienda}</td>
                                                                <td className="text-center">{v.agendadas}</td>
                                                                <td className="text-center">{v.terminadas}</td>
                                                                <td className="text-center">{v.omitidas}</td>
                                                            </tr>
                                                        ))    
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <div className="card-body">
                    <h5 className="titulo_modal type_text mb-1">Datos de actividades</h5>
                    {(item && item.actividades && item.actividades.length > 0) ?
                        <>
                            {item.actividades.map((ite) => (
                                (ite.estado !== 'Pendiente') &&
                                <div style={{background: ite.color_div, padding: 5, cursor: 'pointer'}}
                                     className="d-flex mb-1" onClick={() => {
                                    getActivity(ite.id_actividad);
                                    setModalItem(true);
                                }}>
                                    <div className="ml-1">
                                            <span className="texto_10"
                                                  style={{color: ite.color}}>Fecha agendada</span><br/>
                                        <strong className="texto_14"
                                                style={{color: ite.color}}>{ite.fecha_agendada}</strong>
                                    </div>
                                    <div className="ml-1">
                                            <span className="texto_10"
                                                  style={{color: ite.color}}>Estado actividad</span><br/>
                                        <strong className="texto_14"
                                                style={{color: ite.color}}>{ite.estado}</strong>
                                    </div>
                                    <div className="ml-1">
                                            <span className="texto_10"
                                                  style={{color: ite.color}}>Realizado por</span><br/>
                                        <strong className="texto_14"
                                                style={{color: ite.color}}>{ite.fecha_agendada}</strong>
                                    </div>
                                    <div className="ml-1">
                                        <span className="texto_10" style={{color: ite.color}}>Tienda</span><br/>
                                        <strong className="texto_14"
                                                style={{color: ite.color}}>{ite.tienda}</strong>
                                    </div>
                                    <div className="ml-1">
                                            <span className="texto_10"
                                                  style={{color: ite.color}}>Estado resultado</span><br/>
                                        <strong className="texto_14"
                                                style={{color: ite.color}}>{ite.estado_resultado}</strong>
                                    </div>
                                </div>
                            ))}
                            {(item.agendadas > 0) &&
                                <div className="mt-1 border_card p-1 d-flex">
                                    <div style={{width: '80%'}}>
                                        <p style={{fontSize: 15, color: '#727E8C'}}>Se encontró un registro agendado</p>
                                    </div>
                                    <div className="text-right" style={{width: '20%'}}>
                                        {/*eslint-disable-next-line*/}
                                        <a href="" onClick={() => {
                                            let date = new Date();
                                            let day = date.getDate();
                                            if (parseInt(day) < 10) {
                                                day = '0' + day;
                                            }
                                            const date_now = anio + '-' + mes + '-' + day;
                                            history.push(`/actividades/${id_usuario}/${usuario}/${id_tienda}/${tienda}/${date_now}/${date_now}`);
                                        }}>Ver</a>
                                    </div>
                                </div>
                            }
                        </>
                        :
                        <div>
                            <p className="texto_18">Resultados</p>
                            <div className="mt-1 border_card p-1 text-center">
                            <p style={{fontSize: 15, color: '#727E8C'}}>No se encontraron datos para la actividad seleccionada</p>
                            </div>
                        </div>
                    }
                    
                </div>
                <div className="card-footer text-center">
                    <button disabled={isLoading} onClick={() => {
                        setModalCreateActivity(true);
                    }} className={`btn btn-calendar mb-1 button_div`}>Agendar
                    </button>
                    <button type="button" onClick={() => {
                        setModal(false);
                    }} className={`btn btn-outline-calendar button_div`}>Atrás
                    </button>
                </div>
            </Modal>
            <Modal className="modal-main div-modal" show={modalCreateActivity}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agendar Actividades</h5>
                        <div className="form-group">
                            <label>Actividad</label>
                            <SelectInput
                                id="id_actividad_trabajo"
                                label="Actividad"
                                name="id_actividad_trabajo"
                                value={item.id_actividad_trabajo}
                                select={item.actividad_trabajo}
                                disabled={true}
                                options={[{
                                    name: item.actividad_trabajo,
                                    id: item.id_actividad_trabajo,
                                }]}
                            />
                        </div>
                        <div className="form-group">
                            <label>Tienda</label>
                            <SelectInput
                                id="id_tienda"
                                label="Tienda"
                                name="id_tienda"
                                value={item.id_tienda}
                                select={item.tienda}
                                disabled={true}
                                options={[{
                                    name: item.tienda,
                                    id: item.id_tienda,
                                }]}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                name="fecha_agendada"
                                type="date"
                                label="Fecha agendada"
                                value={fecha_agendada}
                                onChange={e => setFechaAgendada(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalCreateActivity(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal" show={modalItem}>
                <div className="card-body">
                    <h5 className="titulo_modal type_text mb-1">{data.actividad}</h5>
                    <div style={{background: data.color_div, padding: 5, cursor: 'pointer'}} className="d-flex mb-1">
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Fecha agendada</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.fecha_agendada}</strong>
                        </div>
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Estado actividad</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.estado}</strong>
                        </div>
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Realizado por</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.fecha_agendada}</strong>
                        </div>
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Tienda</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.tienda}</strong>
                        </div>
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Estado resultado</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.estado_resultado}</strong>
                        </div>
                    </div>
                    {data.descripcion_actividad &&
                        <div className="border_card col-12" style={{background: "#f2f2f2"}}>
                            <p>Descripción: {data.descripcion_actividad}</p>
                        </div>
                    }
                    {(data && data.resultados && data.resultados.length > 0) && 
                        <div className="mt-1">
                            <p className="texto_16">Archivos de resultados</p>
                            {data.resultados.map((_) => (
                                <div className="d-flex border_card">
                                    <div style={{width: '60%'}} className="ml-1">
                                        <span className="texto_14">{_.nombre_template}</span><br/>
                                        {!_.archivo ?
                                                <span className="texto_14">Pendiente</span>
                                            :
                                                <span className="texto_14">Cargado</span>
                                        }
                                    </div>
                                    <div className="text-right" style={{width: '40%'}}>
                                        {_.archivo &&
                                            <>
                                                {/*eslint-disable-next-line*/}
                                                <a href={_.archivo} target="_blank" className="ml-1">Descargar</a>
                                            </>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                    {(data && data.imagenes && data.imagenes.length > 0) && 
                        <div className="mt-1">
                            <p className="texto_16">Fotografías de evidencia</p>
                            <div className="border_card d-flex">
                                {data.imagenes.map((_) => (
                                    <div className="text-center mr-1" style={{width: '30%'}}>
                                        <img
                                            src={_.imagen}
                                            width={100}
                                            height={90}
                                            alt={_.nombre}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                    <div className="mt-1">
                        <p className="texto_16">Observaciones finales</p>
                        <div className="border_card row">
                            <div className="col-6">
                                <span className="texto_14">Observacón final</span>
                                <p className="border_card">{data.observacion}</p>
                            </div>
                            <div className="col-6">
                                <span className="texto_14">Riesgo</span>
                                <p className="border_card">{data.riesgo}</p>
                            </div>
                            <div className="col-6">
                                <span className="texto_14">Responsable</span>
                                <p className="border_card">{data.responsable}</p>
                            </div>
                            <div className="col-6">
                                <span className="texto_14">Notificado a administración</span>
                                <p className="border_card">NO</p>
                            </div>
                            <div className="col-12">
                                <span className="texto_14">Comentario</span>
                                <p className="border_card">{data.comentario}</p>
                            </div>
                        </div>
                    </div>
                    {(data && data.adicionales && data.adicionales.length > 0) && 
                        <div className="mt-1">
                            <p className="texto_16">Datos adicionales</p>
                            <div className="border_card row">
                                {data.adicionales.map((_) => (
                                    <div className="col-6">
                                        <span className="texto_14">{_.label}</span>
                                        <p className="border_card">{_.value}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                </div>
                <div className="card-footer text-center">
                    <button type="button" onClick={() => {
                        setModalItem(false);
                    }} className={`btn btn-calendar button_div`}>Atrás
                    </button>
                </div>
            </Modal>
            <Footer/>
        </div>
    );
};

export default MonthlyMonitoringProcess;
